import React from 'react';
import { t } from "i18next";
import styles from "./Pricing.module.css";

const PricingTabs = ({ activeTab, setActiveTab }) => {
    return (
        <div className={styles.tabs}>
            <button
                className={`${styles.tabButton} ${activeTab === "annually" ? styles.active : ""}`}
                onClick={() => setActiveTab("annually")}
            >
                {t("general.UI.corporate")}
            </button>
            <button
                className={`${styles.tabButton} ${activeTab === "monthly" ? styles.active : ""}`}
                onClick={() => setActiveTab("monthly")}
            >
                {t("general.UI.domestic")}
            </button>
        </div>
    );
};

export default PricingTabs; 